export class OpportunityContract {
  salesHubContractNumber: string;
  salesHubContractType: string;
  ipContractId: number;
  legalName: string;
  firstName: string;
  lastName: string;
  opportunityStage: string;
  contractStatus: string;
  acgStatusId: number;
  opportunityId: number;
  opportunityName: string;
  assetControlGroupId: number;
  currencyCode: string;
  shContractStatus: string;
  opportunityType: string;
  primaryAuctionEvent: string;
  primaryAuctionEventId: number;
  packageCreateDt: Date;
  assetCount: number;
  oppTmOwner: string;
  contractChannel: string;
}
